import { TagsMock } from '../../mock/tags';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  InterestContainer,
  Tags,
  CheckBox,
  OneTag,
  TagName,
  Title,
  Button,
} from './interest.styles';

export default function Interests({ goToNext }) {
  const [theList, setTheList] = useState(TagsMock);
  const [selectedCount, setSelectedCount] = useState(0);

  const checkSpan = (index) => {
    let checkedList = [...theList];
    checkedList[index].checked = !checkedList[index].checked;
    setTheList(checkedList);
    // count the checked items in the list and set the state
    setSelectedCount(selectedCount + (checkedList[index].checked ? 1 : -1));
  };

  const submitData = (e) => {
    e.preventDefault();
    // selected items - only names
    let selectedTags = [];
    theList.forEach((item) => {
      if (item.checked) {
        selectedTags.push(item.name);
      }
    });
    goToNext(selectedTags);
    console.log('selectedTags', selectedTags);
  };

  return (
    <InterestContainer>
      <Title>Select 3 interests to enrich your feed</Title>
      <Tags>
        {theList.map((tag, index) => (
          <OneTag key={index}>
            <CheckBox
              type="checkbox"
              name={tag.name}
              value={tag.name}
              checked={tag.checked}
              onChange={() => checkSpan(index)}
              disabled={selectedCount === 3 && !tag.checked}
              required
            />
            <TagName>{tag.name}</TagName>
          </OneTag>
        ))}
      </Tags>
      <Button disabled={selectedCount != 3} onClick={(e) => submitData(e)}>
        Next
      </Button>
    </InterestContainer>
  );
}

Interests.propTypes = {
  goToNext: PropTypes.func,
};
